/* eslint-disable no-console */
/* eslint-disable import/first */
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate } from '@reach/router';
import Button from '@material-ui/core/Button';
import Loader from '../Loader';
const { selectDesktop } = Slices.appSlice;
const { selectStoreById } = Slices.storeSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectBaseURL, selectOrderModesByCountry, selectCountryValidations } = Slices.configSlice;
const { selectFirstCategory } = Slices.categorySlice;
const { sendCart, cartItems, clearCart } = Slices.cartSlice;
const { postAddressPickup, choseStore, validateLocation } = Slices.addressSlice;
const { selectLoginStatus } = Slices.authSlice;
const { selectFirstMenu } = Slices.menuSlice;
const { clearCustomizeItems } = Slices.tempCartSlice;
import { ChangeLocationConfirm } from '../../components/SavedAddress';
import DialogBox from '../DialogBox';
import DrawerPwa from '../DrawerPwa';
// import { Badge } from '../Icons';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';
import {
  storeSelectionAttemptGA,
  storeSelectionFailureGA,
  storeSelectionSuccessGA,
} from 'spwa-ui-library/esm/utils/helperGA';
import { generateCategoryRoute } from 'spwa-ui-library/esm/utils/path';
import css from './index.module.scss';
import ClassNames from 'classnames';
// import SetLoader from '../../containers/Carhop/SetLoader';
// eslint:fix Setloader is defined but never used
function StoreLocatorPlaceOrder({ storeId, isOpen, setOpen }) {
  const intl = useIntl();
  const navigate = useNavigate();
  const firstCategory = useSelector(selectFirstCategory);
  const dispatch = useDispatch();
  const store = useSelector((state) => selectStoreById(state, storeId));
  const isDesktop = useSelector(selectDesktop);
  const country = useSelector(selectCurrentCountry);
  const profile = useSelector((state) => state.profile);
  const offer = useSelector((state) => state.offer);

  const cart = useSelector(cartItems);
  const couponCode = offer.apply ? offer.apply.couponCode : '';
  const orderModes = useSelector((state) => selectOrderModesByCountry(state, country));
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const imgBaseUrl = useSelector(selectBaseURL);
  const user = useSelector(selectLoginStatus);
  const [selectMode, setSelectMode] = useState('');
  const [cartDropPopup, setCartDropPopup] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const [errorState, setError] = React.useState(false);
  console.log('eslint:fix console', { errorMsg, errorState });
  const [deliveryInstruction, setDeliveryInstruction] = useState('');
  const [pageLoader, setPageLoader] = useState(false);
  const [errorText, setErrorText] = useState('');
  // const [pageLoad, setPageLoad] = React.useState(false);
  // eslint:fix pageLoad is assigned but never used
  const menu = useSelector(selectFirstMenu);
  // const firstMenu = useSelector(selectFirstMenu);
  console.log(storeId, 'iddd');
  const types = {
    STORE: store?.services?.tak,
    DELIVERY: 0,
    CARHOP: store?.services?.carHop,
    DINEIN: store?.services?.din,
    DRIVETHRU: store?.services?.driveThru,
  };
  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
    if (inputValue === sanitizedValue || inputValue === '') {
      setDeliveryInstruction(sanitizedValue);
    }
  };
  const handleSelectMode = (type) => {
    setSelectMode(type);
    setDeliveryInstruction('');
  };
  const onStoreLocationChange = () => {
    var selectedStore = store;
    var tempID;
    var menuID;
    let payload = {
      screen: 'HOME',
      addressSubType: selectMode,
      storeId: selectedStore?.storeId,
      areaId: selectedStore.areaId,
      lat: selectedStore?.location?.latitude,
      lng: selectedStore?.location?.latitude,
    };
    setPageLoader(true);
    if (cart.length) {
      dispatch(validateLocation(payload)).then((resp) => {
        setPageLoader(false);
        if (!resp.error) {
          // tempID = resp?.payload?.data?.data?.menuTempId || tempID;
          // menuID = resp?.payload?.data?.data?.menuId || menuID;

          // if (tempID !== menu.menuTempId || menuID !== menu.menuId) {
          //   setCartDropPopup(true);
          // } else {
          handleProceed();
          // }
        } else {
          // if (
          //   selectedStore.menuId !== menu.menuId ||
          //   selectedStore.menuTempId !== menu.menuTempId
          // ) {
          //   setCartDropPopup(true);
          // } else {
          handleProceed();
          // }
          setError((prev) => true);
          setErrorMsg((old) => resp.error.message);
        }
      });
    } else {
      handleProceed();
    }
  };

  const handleProceed = () => {
    // eslint:fix selectMode === is modified
    const type = selectMode === 'STORE' || selectMode === 'CARHOP' ? 'PICKUP' : selectMode;
    const addressPayload = {
      addressSubType: selectMode,
      addressType: type,
      addressVia: 'DEFAULT',
      areaId: store.areaId,
      storeId: store.storeId,
    };
    setPageLoader(true);
    dispatch(choseStore({ city: store.cityId, store: store.id, instruction: deliveryInstruction }));
    dispatch(postAddressPickup(addressPayload))
      .then((addRespons) => {
        setPageLoader(false);
        if (addRespons.meta.requestStatus !== 'rejected') {
          window.localStorage.setItem(
            'selectedAddress',
            JSON.stringify(addRespons?.payload?.data?.data)
          );
          window.localStorage.setItem('_add', JSON.stringify(addRespons?.payload?.data?.data));
          storeSelectionSuccessGA(user);
          // debugger;
          const payload = {
            body: {
              addressSubType: selectMode,
              addressType: type,
              addressId: addRespons?.payload?.data?.data?.id || '',
              cartId: profile.data.data[0].cartId,
              applySurprisePromo: couponCode?.length > 0,
              clusterId: addRespons?.payload?.data?.data?.clusterId || '',
              items: cart,
              version: 'v20',
              orderType: type,
              storeId: store.storeId,
            },
            headers: {
              country: profile.country,
            },
          };

          dispatch(sendCart(payload)).then((resp) => {
            if (resp.meta.requestStatus !== 'rejected') {
              const exploreMenuPath = generateCategoryRoute({
                category: firstCategory,
                locale: intl?.locale,
              });

              navigate(exploreMenuPath);
            }
          });
        } else {
          storeSelectionFailureGA(user);
          setErrorText(addRespons.error.message);
          setPageLoader(false);
        }
      })
      .catch((error) => {
        setPageLoader(false);
        storeSelectionFailureGA(user);
        console.log(error);
      });
    storeSelectionAttemptGA(user);
  };
  const instr = {
    CARHOP: {
      heading: (
        <FormattedMessage id="vehicle_info" defaultMessage="Vehicle and Location Details*" />
      ),
      placeholder: countryValidations?.carHopInstrPlaceholder,
      instrNode: countryValidations?.carHopInstrNode,
    },
    DINEIN: {
      heading: <FormattedMessage id="dinein_details" defaultMessage="Dine-In Details" />,
      placeholder: countryValidations?.dineInInstr?.placeholder,
      instrNode: countryValidations?.dineInInstr.note,
    },
  };

  const onlyAlphaNumeric = (event) => {
    const charCode = event.keyCode || event.which;
    if (charCode === 8) {
      return true;
    }

    if (
      (charCode >= 48 && charCode <= 57) ||
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122)
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  const isDisabled = selectMode === 'CARHOP' && deliveryInstruction === '' ? true : false;

  const placeOrderRender = () => {
    return (
      <>
        <div className={css.root}>
          {pageLoader && <Loader />}
          <div className={css.head}>
            {/* <Badge /> */}
            <h3>
              <FormattedMessage
                id="storeLocatorDetail_how"
                defaultMessage="How would you like your order?"
              />
            </h3>
          </div>
          <div className={css.modesWrapper}>
            {orderModes.map((el) => {
              const title = intl.locale.toLowerCase() === 'en' ? el.name : el.nameAr;
              const selected = selectMode === el.type ? true : false;
              const imgSrc = `${imgBaseUrl.home}${selected ? el.imageAlt : el.image}`;
              //  : orderMode.image
              if (!types[el.type] || !el.enable) {
                return '';
              }
              return (
                <div
                  onClick={() => handleSelectMode(el.type)}
                  className={ClassNames(css.itm, { [css.active]: selected })}
                >
                  <div className={css.typeIcon}>
                    <img width="70" src={imgSrc} alt={title} />
                  </div>
                  {selected ? (
                    <div className={css.selectTick}>
                      <FaCheck />{' '}
                    </div>
                  ) : (
                    ''
                  )}
                  <div className={css.typeTitle}>{title}</div>
                </div>
              );
            })}
          </div>
          {selectMode === 'CARHOP' || selectMode === 'DINEIN' ? (
            <div className={css.deliveryIns}>
              <div className={css.heading}>{instr[selectMode].heading}</div>

              <div className={css.input}>
                <input
                  type="text"
                  placeholder={instr[selectMode].placeholder}
                  maxLength={selectMode === 'CARHOP' ? 40 : 3}
                  value={deliveryInstruction}
                  onChange={handleInputChange}
                  onKeyDown={onlyAlphaNumeric}
                />
                <div className={css.example}>
                  <span className={css.nodeStyle}> {instr[selectMode].instrNode}</span>
                  <span className={css.nodeStyle}>
                    {selectMode === 'CARHOP' ? (
                      <FormattedMessage id="40_max_char" defaultMessage="40 Max Character" />
                    ) : (
                      <FormattedMessage id="3_max_digits" defaultMessage="3 max digits" />
                    )}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
          {errorText !== '' ? (
            <div className={css.warningText}>
              <span>{errorText}</span>
            </div>
          ) : (
            ''
          )}
          <div className={css.action}>
            <Button
              variant="contained"
              color="primary"
              onClick={onStoreLocationChange}
              disabled={selectMode === '' || isDisabled}
            >
              <FormattedMessage id="storeLocator_continue" defaultMessage="Continue" />
            </Button>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      {/* {pageLoader && <Loader />} */}
      {!cartDropPopup && (
        <>
          {isDesktop ? (
            <DialogBox
              title=""
              size="sm"
              isOpen={isOpen}
              onClose={() => setOpen(false)}
              page="login"
            >
              {placeOrderRender()}
            </DialogBox>
          ) : (
            <DrawerPwa
              variant="temporary"
              anchor="bottom"
              open={isOpen}
              onClose={() => setOpen(false)}
            >
              {placeOrderRender()}
            </DrawerPwa>
          )}
        </>
      )}

      {cartDropPopup && (
        <ChangeLocationConfirm
          isOpen={cartDropPopup}
          onCancel={() => {
            setCartDropPopup(false);
          }}
          onConfirm={() => {
            handleProceed();
          }}
        />
      )}
    </>
  );
}

export default StoreLocatorPlaceOrder;
